import _ from 'lodash'
import { HoldingsMutationTypes } from './mutations-type'
import storage, { StorageType } from '@/utils/storage'

const assetsDetailEmpty = ['', null, undefined]
const initialState = {
  isShowAssetsDetail: assetsDetailEmpty.includes(storage.rcGetItem(StorageType.local, 'isShowAssetsDetail')) ? true : storage.rcGetItem(StorageType.local, 'isShowAssetsDetail'),
  currencyActive: {
    name: '港元',
    value: 'HKD'
  },
  accountTypeActive: {
    label: '证劵账户',
    value: 'STOCK'
  },
  marketTypeActive: {
    label: '港股',
    value: 'HK'
  },
  fundAccMarketList: {
    fundAccount: '',
    moneyType: '',
    exchangeType: '',
    marketValue: '--',
    fetchBalance: '--',
    frozenBalance: '--',
    enableBalance: '--'
  },
  stockPosPageList: [],
  bondPosPageList: {
    mv: [],
    rows: [],
    statisInfo: []
  },
  fundPosPageList: {
    mv: [],
    rows: [],
    statisInfo: []
  },
  otherPosPageList: {
    mv: [],
    rows: []
  },
  spsPosPageList: {
    rows: [],
    totalMv: []
  },
  clientLifecycle: {
    lifecycles: []
  }

}

const state = _.cloneDeep(initialState)

const mutations = {
  [HoldingsMutationTypes.SET_CURRENCY_ACTIVE] (state: any, currency: { name: string, value: string }) {
    state.currencyActive = currency
  },
  [HoldingsMutationTypes.SET_ACCOUNT_TYPE_ACTIVE] (state: any, accountType: { label: string, value: string }) {
    state.accountTypeActive = accountType
  },
  [HoldingsMutationTypes.SET_MARKET_TYPE_ACTIVE] (state: any, marketType: { label: string, value: string }) {
    state.marketTypeActive = marketType
  },
  [HoldingsMutationTypes.SET_FUND_ACC_MARKET_LIST] (state: any, fundAccMarketList: { fundAccount: string, moneyType: string, exchangeType: string, marketValue: string, fetchBalance: string, frozenBalance: string, enableBalance: string }) {
    state.fundAccMarketList = fundAccMarketList
  },
  [HoldingsMutationTypes.SET_STOCK_POS_PAGE_LIST] (state: any, stockPosPageList: any[]) {
    state.stockPosPageList = stockPosPageList
  },
  [HoldingsMutationTypes.SET_BOND_POS_PAGE_LIST] (state: any, bondPosPageList: any[]) {
    state.bondPosPageList = bondPosPageList
  },
  [HoldingsMutationTypes.SET_FUND_POS_PAGE_LIST] (state: any, fundPosPageList: any[]) {
    state.fundPosPageList = fundPosPageList
  },
  [HoldingsMutationTypes.SET_EXTRA_POS_PAGE_LIST] (state: any, extraPosPageList: any) {
    state.extraPosPageList = extraPosPageList
  },
  [HoldingsMutationTypes.SET_SPS_POS_PAGE_LIST] (state: any, spsPageList: any[]) {
    state.spsPosPageList = spsPageList
  },
  [HoldingsMutationTypes.SET_CLIENT_LIFECYCLE] (state: any, clientLifecycle: any[]) {
    state.clientLifecycle = clientLifecycle
  },
  [HoldingsMutationTypes.SET_IS_SHOW_ASSETS_DETAIL] (state: any, isShowAssetsDetail: boolean) {
    state.isShowAssetsDetail = isShowAssetsDetail
  },
  [HoldingsMutationTypes.SET_EXTRA_FUND_ASSET_ALL_INFO] (state: any, extraFundAssetAllInfo: any) {
    state.extraFundAssetAllInfo = extraFundAssetAllInfo
  },
  [HoldingsMutationTypes.RESET_STATE] (state: any) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  }
}

export default {
  state,
  mutations
}
